import type { PresentedSnapshot } from "../../presentation/mesh";
import type { RelationPath } from "../scene/RelationPathProjector";

export type RelationBinding = { path: RelationPath; reversed: boolean };

export class RelationRegistry {
  private readonly paths = new Map<string, RelationBinding>();
  private readonly related = new Map<string, Set<string>>();
  private readonly empty = new Set<string>();

  rebuild(snapshot: PresentedSnapshot) {
    this.related.clear();
    for (const node of snapshot.nodes) this.related.set(node.id, new Set([node.id]));
    for (const edge of snapshot.edges) {
      this.related.get(edge.source)?.add(edge.target);
      this.related.get(edge.target)?.add(edge.source);
    }
    for (const orbital of snapshot.orbitalNodes) this.related.get(orbital.parentId)?.add(orbital.id);
  }

  register(source: string, target: string, path: RelationPath) {
    this.paths.set(key(source, target), { path, reversed: false });
    this.paths.set(key(target, source), { path, reversed: true });
  }

  binding(source: string, target: string) {
    return this.paths.get(key(source, target)) ?? null;
  }
  relatedIds(nodeId: string | null): ReadonlySet<string> {
    return nodeId ? (this.related.get(nodeId) ?? this.empty) : this.empty;
  }
  clear() {
    this.paths.clear();
    this.related.clear();
  }
}

function key(source: string, target: string) {
  return `${source}→${target}`;
}
